// extracted by mini-css-extract-plugin
export default {"experiences-shop-what-to-expect-container":"_9yufyBEKSzg6N3AolnRPBA=="};